import UIAsset from 'components/atoms/UIAsset';
import * as React from 'react';

type ProgressMetaData = {
	active: boolean;
	strokeHigh: any;
	percent: number;
	floatText: any;
	pushText: any;
	large: boolean;
	title: string;
	label: string;
};

export type ProgressPointsProps = {
	modifier?: string;
	current?: number;
	label: string;
	sticker?: string;
	progress: number;
	steps?: Array<{ active?: boolean; number: number; percent: number }>;
	max: number;
	overlap?: boolean;
	record?: ProgressMetaData & {
		progress: number;
		percent: number;
	};
	actual?: ProgressMetaData;
};

export default class ProgressPoints extends React.Component<ProgressPointsProps> {
	public static displayName = 'ProgressPoints';

	public static defaultProps = {
		overlap: false,
	};

	public renderWithSticker() {
		const { overlap = 0, progress, sticker, steps = [] } = this.props;
		const output: JSX.Element[] = [];

		output.push(
			<div
				key="chart"
				className={`m-progress-points__chart${overlap ? ' m-progress-points__chart--overlap' : ''}`}
			>
				<div className="m-progress-points__chart-line">
					<div className="m-progress-points__chart-line-filled" style={{ width: `${progress}%` }} />
				</div>
				<ul className="m-progress-points__chart-axis">
					{steps &&
						steps.map((step, index) => {
							return (
								<li
									key={index}
									className={`m-progress-points__chart-step${
										step.active ? ' m-progress-points__chart-step--active' : ''
									}`}
									style={{ left: `${step.percent}%` }}
								>
									<span className="m-progress-points__chart-number">{step.number}</span>
								</li>
							);
						})}
				</ul>
			</div>
		);
		output.push(
			<div key="sticker" className="m-progress-points__sticker">
				<UIAsset
					className="m-progress-points__sticker-img"
					src={`img/svg/award/${sticker || ''}`}
					alt={sticker}
				/>
			</div>
		);
		return output;
	}

	public renderWithoutSticker() {
		const { record, actual, steps, progress, overlap, max } = this.props;
		const overlapRecord = record && record.progress && record.progress > max && !overlap;

		return (
			<div
				className={`m-progress-points__chart m-progress-points__chart--entire ${
					overlap ? ' m-progress-points__chart--overlap' : ''
				} ${overlapRecord ? ' m-progress-points__chart--overlap-record' : ''}`}
			>
				<div className="m-progress-points__chart-line">
					{record && (
						<div className="m-progress-points__chart-line-record" style={{ width: `${record.percent}%` }} />
					)}
					<div className="m-progress-points__chart-line-filled" style={{ width: `${progress}%` }} />
				</div>

				<ul className="m-progress-points__chart-axis">
					{steps &&
						steps.map((step, index) => {
							return (
								<li
									key={index}
									className={`m-progress-points__chart-step${
										step.active ? ' m-progress-points__chart-step--active' : ''
									}`}
									style={{ left: `${step.percent}%` }}
								>
									<span className="m-progress-points__chart-number">{step.number}</span>
								</li>
							);
						})}

					{actual && (
						<li
							className={`m-progress-points__chart-actual ${
								actual.active ? 'm-progress-points__chart-actual--active' : ''
							} ${actual.strokeHigh ? 'm-progress-points__chart-actual--stroke-high' : ''}`}
							style={{ left: `${actual.percent}%` }}
						>
							<div
								className={`m-progress-points__chart-text ${
									actual.floatText ? `m-progress-points__chart-text--float-${actual.floatText}` : ''
								} ${actual.pushText ? `m-progress-points__chart-text--push-${actual.pushText}` : ''} ${
									actual.large ? 'm-progress-points__chart-text--large' : ''
								}`}
							>
								{actual.title && <span className="m-progress-points__chart-label">{actual.title}</span>}
								{actual.label && <span className="m-progress-points__chart-label">{actual.label}</span>}
							</div>
						</li>
					)}

					{record && actual && (
						<li
							className={`m-progress-points__chart-record ${
								record.active ? 'm-progress-points__chart-record--active' : ''
							} ${record.strokeHigh ? 'm-progress-points__chart-record--stroke-high' : ''}`}
							style={{ left: `${record.percent}%` }}
						>
							<div
								className={`m-progress-points__chart-text ${
									record.floatText ? `m-progress-points__chart-text--float-${record.floatText}` : ''
								} ${record.pushText ? `m-progress-points__chart-text--push-${record.pushText}` : ''}`}
							>
								{record.title && <span className="m-progress-points__chart-label">{record.title}</span>}
								{record.label && <span className="m-progress-points__chart-label">{record.label}</span>}
							</div>
						</li>
					)}
				</ul>
			</div>
		);
	}

	public renderInfo() {
		const { label, current = 0 } = this.props;
		return (
			<div className="m-progress-points__info">
				<span className="m-progress-points__info-number">{current}</span>
				<span className="m-progress-points__info-text">{label}</span>
			</div>
		);
	}

	public render() {
		const { sticker, modifier } = this.props;
		return (
			<div className={`m-progress-points${modifier ? ` m-progress-points--${modifier}` : ''}`}>
				{modifier !== 'overall' && this.renderInfo()}
				{sticker ? this.renderWithSticker() : this.renderWithoutSticker()}
			</div>
		);
	}
}
